import React, { useState } from 'react';
import PropType from 'prop-types'
import BoxError from '../../Atoms/BoxError';
import SourceIdLink from '../SourceIdLink';
import { testAttributes } from './Constants';

const MortgageRatesTableError = ({ applyNowUrl }) => 
{
    const [showAlert, setShowAlert] = useState(true);

    if (!showAlert) return null;

    return (
        <div className="mortgage-rates-error-container" data-testid={testAttributes.MORTGAGE_RATES_ERROR_CONTAINER}>
            <BoxError
                type="danger"
                closeAlert={() => setShowAlert(false)}
                msg={
                    <>
                        We are sorry, but rates are unavailable at the moment.
                        To find your custom rates,{' '}
                        <SourceIdLink href={applyNowUrl}>
                            get started here
                        </SourceIdLink>
                        .
                    </>
                }
            />
        </div>
    );
};

MortgageRatesTableError.propTypes = {
    /** Required. URL, if containing sourceid query, will be processed for replacement */
    applyNowUrl: PropType.string.isRequired
}

export default MortgageRatesTableError;
